/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkDeleteFacilityServiceAreasRequest
 */
export interface BulkDeleteFacilityServiceAreasRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDeleteFacilityServiceAreasRequest
     */
    ids: Array<string>;
}

/**
 * Check if a given object implements the BulkDeleteFacilityServiceAreasRequest interface.
 */
export function instanceOfBulkDeleteFacilityServiceAreasRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ids" in value;

    return isInstance;
}

export function BulkDeleteFacilityServiceAreasRequestFromJSON(json: any): BulkDeleteFacilityServiceAreasRequest {
    return BulkDeleteFacilityServiceAreasRequestFromJSONTyped(json, false);
}

export function BulkDeleteFacilityServiceAreasRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkDeleteFacilityServiceAreasRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function BulkDeleteFacilityServiceAreasRequestToJSON(value?: BulkDeleteFacilityServiceAreasRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ids': value.ids,
    };
}

